<template>
  <div id="app">
    <!-- <div class="migrate-hint">
      <p>
        The new version is on the way, check out for the new looking and functions:
        <a href="https://test-metrics.garena.tw" target="_blank" rel="noopener noreferrer">
          <strong>https://test-metrics.garena.tw</strong>
        </a>
      </p>

      <p>
(We are planning to release the new version on <strong>17 June</strong>, let us know if you have any feedback!)</p>
    </div> -->
    <loading
      :active.sync="isLoading"
      :is-full-page="true">
    </loading>
    <div>
      <img src="./assets/img/logo.png">
      <h1 class="title">Mobile Game Ranking Report</h1>
    </div>
    <div v-if="isLogin">
      <subscriber-block @updateStatus="updateStatus" @logout="logout" @subscribe="subscribe" @unsubscribe="unsubscribe" :isSubscribed="isSubscribed" :isLogin="isLogin" :userInfo="userInfo"/>
      <section class="section">
        <search-block @search="generateReport" @refetch="refetchData" />
      </section>
      <section v-if="showReport" class="section">
        <report id="report_content" :report="report" :date="reportDate" />
        <!-- <div class="buttom-area">
          <a class="button is-link" @click="copyHtml()">Copy Report</a>
          <span class="notice">{{ copiedAlert }}</span>
        </div> -->
      </section>
    </div>
    <div v-show="!isLogin">
      <div id="google-one-tap" class="google-one-tap"></div>
      <div id="google-sign-in" class="g-signin-button"></div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import Report from './components/Report.vue';
import SearchBlock from './components/SearchBlock.vue';
import SubscriberBlock from './components/SubscriberBlock.vue';
import services from './services';
import utils from './utils';

export default {
  name: 'app',
  components: {
    Loading,
    Report,
    SearchBlock,
    SubscriberBlock,
  },
  data: function() {
    return {
      showReport: false,
      report: null,
      copiedAlert: '',
      isLoading: false,
      reportDate: '',
      isSubscribed: false,
      isLogin: false,
      userInfo: {},
    }
  },
  mounted() {
    const localIdToken = localStorage.getItem('googleIdToken');
    if (localIdToken) {
      this.login(localIdToken, (result) => {
        if ('error' in result) {
          localStorage.removeItem('googleIdToken');
        } else {
          this.updateStatus(result);
        }
      });
    }
    this.initLoginBtn();
  },
  methods: {
    async generateReport(date) {
      const pattern = /([12]\d{3}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01]))/;
      if (!date) {
        alert('Please select date.');
        return
      } else if (!date.match(pattern)) {
        alert('Date format error.');
      }

      this.isLoading = true;
      this.reportDate = date;
      const result = await services.getMetrics(date);
      this.isLoading = false;
      this.report = result.data;
      this.showReport = true;
      this.copiedAlert = '';
    },
    async refetchData(date) {
      const pattern = /([12]\d{3}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01]))/;
      if (!date) {
        alert('Please select date.');
        return
      } else if (!date.match(pattern)) {
        alert('Date format error.');
      }

      this.isLoading = true;
      this.result = await services.refetchData(date);
      this.isLoading = false;

      if (this.result.success) {
        alert('Data is under refetching, please wait around 3 minutes.');
      } else {
        alert('Data is under refetching, please wait around 3 minutes.');
      }
    },
    async login(id_token, callback) {
      this.isLoading = true;
      let result = await services.login(id_token);
      this.isLoading = false;

      callback(result);
    },
    async logout() {
      this.isLoading = true;
      localStorage.removeItem('googleIdToken');
      await services.logout();
      this.isSubscribed = false;
      this.isLogin = false;
      this.isLoading = false;
      window.google.accounts.id.prompt();
    },
    async subscribe() {
      this.isLoading = true;
      let result = await services.subscribe();
      this.isLoading = false;

      this.updateStatus(result);
    },
    async unsubscribe() {
      this.isLoading = true;
      let result = await services.unsubscribe();
      this.isLoading = false;

      this.updateStatus(result);
    },
    copyHtml() {
      utils.copyHtml();
      this.copiedAlert = 'Copied';
    },
    updateStatus(result) {
      if ('error' in result) {
        alert(result.error);
      } else {
        this.isLogin = result.isLogin;
        this.isSubscribed = result.isSubscribed;
      }
      if ('userInfo' in result) {
        this.userInfo = result.userInfo;
      }
    },
    initLoginBtn() {
      window.google.accounts.id.initialize({
        client_id: '90144711899-lv6plhl8qnei2tjaotoar3cnvpe7eo1f.apps.googleusercontent.com',
        callback: (response) => {
          this.login(response.credential, this.updateStatus);
        },
        prompt_parent_id: 'google-one-tap',
        auto_select: true,
      });
      window.google.accounts.id.renderButton(
        document.getElementById('google-sign-in'),
        { theme: 'filled_blue' },
      );
      window.google.accounts.id.prompt();
    }
  }
}
</script>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/bulma/0.7.5/css/bulma.min.css";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.notice {
  display: inline-block;
  padding: 10px;
}

.buttom-area {
  display: block;
}

.g-signin-button {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}

.google-one-tap {
  right: 20px;
  top: 20px;
  width: 391px;
  height: 186px;
  z-index: 9999;
  position: fixed;
}

::v-deep iframe {
  margin: 0 !important;
}

.migrate-hint {
  margin-bottom: 60px;
  background-color: rgb(0, 220, 130);
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
}

.migrate-hint strong {
  font-weight: 700;
}

.migrate-hint a {
  color: black;
  cursor: pointer;
}

.migrate-hint a:hover {
  text-decoration: underline;
}
</style>
